<template>
	<nk-page :commercialAccess="['Sale', 'Warehouse']" :policyClaims="['Product_ProductFloating_Management']">
		<template #badges>
			<nk-badge system="sale">
				<nk-badge-item type="system" modelValue="sale"></nk-badge-item>
			</nk-badge>
		</template>
		<ag-grid :options="tableOptions" :data="productFloatingList" :key="rerenderGrid" @row_dbClicked="rowDbClicked" @preSelectedRowData="(val) => selectedRow = val" ref="productFloatingListTable" startup tabindex="101"></ag-grid>

	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import ProductsFloatingModify from './product-floating-modify'
	import $sc from '~/plugins/shortcut.collection.js'
	import validators, { isEmpty } from '~/statics/validators'
	import { mapGetters, mapActions, mapState } from 'vuex'
	import Endpoints from '@nikan/endpoints'
	import emptyId from '~/statics/empty-id'
	import BooleanLabel from '~/components/form/boolean-label'
	import dialog from '~/plugins/nikan-dialog-plugin'

	export default {
		name: 'product-floating-list',
		modal: {
			size: 'lg',
			stateUID: 'product-floating-list',
			helpTag: 'ProductFloatingList'
		},
		props: {
			data: { type: Object },
			options: {},
		},
		data() {
			return {
				settings: {},
				productFloatingList: [],
				rerenderGrid: 0,
				newProductFloating: {
					id: emptyId,
					name: '',
					displayOrder: null,
					isEnabled: true,
					productFloatingValues: [],
				},
				selectedRow: null,
				tableOptions: {
					id: this.$options.name,
					doubleClickedToSelect: true,
					enterToSelect: true,
					rowGroupPanelShow: false,
					groupIncludeTotalFooter: false,
					cellSelectionAggReport: false,
					pagination: false,
					fitToWidth: false,
					sideBar: 'none',
					rowSelection: {
						mode: 'singleRow'
					},
					columnDefs: [
						{
							field: 'rowNumber',
							headerName: this.$t('row-number'),
							width: 68,
						},
						{
							field: 'name',
							headerName: this.$t('sale.product-floating.f.name'),
							// width: 250,
						},
						{
							field: 'valueType',
							headerName: this.$t('sale.product-floating.f.valueType'),
							contentType: 'enum',
							valueFormatter: data => this.$t('ValueTypes.' + data.value.toLowerCase()),

						},
						{
							field: 'dataType',
							headerName: this.$t('sale.product-floating.f.dataType'),

							contentType: 'enum',
							valueFormatter: data => this.$t('ProductFloatingDataTypes.' + data.value.toLowerCase()),
							// width: 200,

						},
						{
							field: 'uniqueMode',
							headerName: this.$t('sale.product-floating.f.uniqueMode'),
							contentType: 'enum',
							valueFormatter: data => this.$t('UniqueModes.' + data.value.toLowerCase()),
							// width: 200,
						},
						{
							field: 'isEnabled',
							headerName: this.$t('sale.product-floating.f.isEnabled'),
							contentType: 'enum',
							valueFormatter: data => data.value ? 'بله' : 'خیر',
							cellRenderer: BooleanLabel,
							cellRendererParams: (data) => {
								return {
									options: {
										useColors: true,
										modelValue: data.value
									}
								}
							},
							// width: 150,
						},
					],

				},
				newProductFloatingButton: {
					title: this.$t('sale.product-floating.insert'),
					shortcut: $sc.find('add'),
					icon: 'plus',
					isPrimary: false,
					handle: () => {
						this.showModal({
							component: ProductsFloatingModify
						}).then(() => { }).catch(() => { })
					},
					policyClaims: 'Product_ProductFloating_Add',
				},
				editProductFloatingButton: {
					title: this.$t('sale.product-floating.edit'),
					shortcut: $sc.find('edit'),
					visible: true,
					icon: 'edit',
					handle: () => {
						this.editProductFloating()
					},
					policyClaims: 'Product_ProductFloating_Edit',
				},
				deleteProductFloatingButton: {
					title: this.$t('delete'),
					shortcut: $sc.find('delete'),
					visible: true,
					icon: 'trash',
					handle: () => {
						this.showDeleteProductFloatingDialog()
					},
					policyClaims: 'Product_ProductFloating_Delete',
				}
			}
		},
		created() {
			this.settings = _.extend({}, this.settings, this.options)
		},
		mounted() {
			this.prepareWindow(this.$t('sale.product-floating-list.title'), [
				this.newProductFloatingButton,
				this.editProductFloatingButton,
				this.deleteProductFloatingButton
			])
			this.selectedRow = this.data
		},
		computed: {
			...mapGetters({
				productFloatings_all: 'productFloatings/all',
			}),
			// productFloatingList() {
			// 	let cloned = _.cloneDeep(this.productFloatings_all)
			// 	return cloned
			// }
		},
		watch: {
			'$store.state.productFloatings.floatings': {
				deep: true,
				immediate: true,
				handler(val) {
					this.productFloatingList = val
					this.rerenderGrid++
				}
			}
		},
		methods: {
			...mapActions({
				broadcastRefresh: 'socket/broadcastRefresh'
			}),
			editProductFloating() {
				if (this.selectedRow) {
					this.showModal({
						component: ProductsFloatingModify,
						data: this.selectedRow
					}).then(() => { }).catch(() => { })
				} else {
					this.$toast(this.$t('sale.product-floating.m.no-product-floating-selected'))
				}
			},
			rowDbClicked(val) {
				if (this.grandParentType() === 'modal')
					this.resolve(val)
			},
			showDeleteProductFloatingDialog() {
				dialog({
					title: this.$t('sale.product-floating.delete-product-floating'),
					body: this.$t(
						'sale.product-floating.m.want-to-delete-product-floating', { name: this.selectedRow.name }
					),
					type: 'warning',
					autoClose: true,
					buttons: [
						{
							title: this.$t('dialog.yes'),
							shortcut: $sc.find('yes', 'dialog'),
							isPrimary: true,
							handle: (button, page, e) => {
								this.deleteProductFloating(this.selectedRow)
							},
						},
						{
							title: this.$t('dialog.cancel'),
							shortcut: $sc.find('cancel', 'dialog'),
							isCancel: true,
							handle: (button, page, e) => { },
						},
					],
				})
			},
			deleteProductFloating(productFloating) {
				var wait = this.$wait(this.$refs.floatingInfo, { size: 'small' })
				post(Endpoints.getUrl('sale.product.floating.delete'), {
					Id: productFloating.id,
				})
					.then((result) => {
						wait.end()
						this.$toast(this.$t('msg.delete-success'), { type: 'success' })
						this.broadcastRefresh('ProductFloatings')
					})
					.catch(() => {
						wait.end()
					})
			},
		},
	}
</script>
<style></style>
